'use client';

export const removeSearchParams = (searchParams: Readonly<URLSearchParams>, keys: string[]) => {
  const newSearchParams = new URLSearchParams(searchParams);
  for (const key of keys) newSearchParams.delete(key);
  return newSearchParams;
};
